module.exports = __webpack_public_path__ + "static/media/nima_hands-side.5e30bc16.png";